import styled from 'styled-components';

export const ConfigStatusTrackingContainerStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    justify-content: space-between;
    height: 100%;
    padding-bottom: 2rem;
`;

export const ConfigStatusTrackingCardsContentStyled = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    align-items: center;
    justify-content: center;
    padding: 0 24px;
`;
